import React from "react";
import { BoardPlaneIcon, airlineColor, THEMES, LIGHT } from "./parts";

const FIELD_SCALE = 1.15;
const vh = (n) => +(n * FIELD_SCALE).toFixed(3) + "vh";

const Footer = ({
  rows,
  isDep,
  airportLabel,
  dateLabel,
  showBoth,
  depRows,
  arrRows,
  theme,
}) => {
  const t = (theme && THEMES[theme]) || LIGHT;
  const s = {
    wrap: {
      height: "100%",
      width: "100%",
      boxSizing: "border-box",
      background: t.wrapBg,
      color: t.text,
      fontFamily: '"Segoe UI", "Helvetica Neue", Arial, sans-serif',
      padding: "0 2vw",
      display: "flex",
      alignItems: "center",
      borderTop: "1px solid " + t.border,
    },
    left: {
      display: "flex",
      alignItems: "center",
      flexShrink: 0,
      marginRight: "2vw",
    },
    badge: {
      background: t.iconBoxBg,
      borderRadius: "1vh",
      padding: vh(1.55),
      display: "flex",
      marginRight: "1vw",
    },
    title: {
      fontSize: vh(5.7),
      fontWeight: 800,
      color: t.title,
      lineHeight: 1,
      textTransform: "uppercase",
    },
    airport: {
      fontSize: vh(2.85),
      color: t.subtitleColor,
      textTransform: "uppercase",
      fontWeight: 600,
    },
    list: {
      flex: 1,
      display: "flex",
      alignItems: "center",
      overflow: "hidden",
      minWidth: 0,
    },
    chip: {
      display: "flex",
      alignItems: "center",
      whiteSpace: "nowrap",
      fontSize: vh(4.4),
      marginRight: "2vw",
    },
    kind: {
      fontSize: vh(2.6),
      fontWeight: 800,
      color: t.accent,
      letterSpacing: "0.06em",
      marginRight: "0.9vw",
    },
    time: { color: t.timeColor, fontWeight: 800, marginRight: "0.9vw" },
    est: { color: t.estColor, fontWeight: 600, marginRight: "0.9vw" },
    airlineBadge: {
      width: vh(4.15),
      height: vh(4.15),
      borderRadius: "0.5vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff",
      fontWeight: 800,
      fontSize: vh(1.8),
      marginRight: "0.9vw",
    },
    flight: { color: t.title, fontWeight: 700, marginRight: "0.9vw" },
    to: { color: t.text, marginRight: "0.9vw" },
    date: {
      flexShrink: 0,
      fontSize: vh(4.15),
      fontWeight: 700,
      color: t.dateColor,
      marginLeft: "2vw",
    },
  };

  const dual = showBoth && (depRows || arrRows);
  const chips = dual
    ? [
        ...(depRows || []).map((r) => ({ ...r, kind: "DEP" })),
        ...(arrRows || []).map((r) => ({ ...r, kind: "ARR" })),
      ]
    : (rows || []).map((r) => ({
        ...r,
        kind: isDep ? "DEP" : "ARR",
      }));

  const title = dual
    ? "DEPARTURES & ARRIVALS"
    : isDep
    ? "DEPARTURES"
    : "ARRIVALS";

  return (
    <div style={s.wrap}>
      <div style={s.left}>
        <span style={s.badge}>
          <BoardPlaneIcon size={vh(4.7)} isDep={isDep} dual={dual} fill={t.iconFill} />
        </span>
        <div>
          <div style={s.title}>{title}</div>
          <div style={s.airport}>{airportLabel}</div>
        </div>
      </div>

      <div style={s.list}>
        {chips.length ? (
          chips.map((r, i) => (
            <span style={s.chip} key={`${r.kind}-${r.flight}-${i}`}>
              {dual && <span style={s.kind}>{r.kind}</span>}
              <span style={s.time}>{r.time}</span>
              <span style={s.est}>{r.est}</span>
              <span
                style={Object.assign({}, s.airlineBadge, {
                  background: airlineColor(r.carrier),
                })}
              >
                {r.carrier}
              </span>
              <span style={s.flight}>{r.flight}</span>
              <span style={s.to}>{r.toCode || r.toCodeShort}</span>
              <span style={{ color: r.status.color, fontWeight: 800 }}>
                {r.status.label}
              </span>
            </span>
          ))
        ) : (
          <span style={{ color: t.textMuted, fontSize: "3vh" }}>
            No {dual ? "flight" : isDep ? "departure" : "arrival"} data.
          </span>
        )}
      </div>

      <div style={s.date}>{dateLabel}</div>
    </div>
  );
};

export default Footer;
